<template>
  <div :class="['audience-click-load-list', {'empty-data': submitList.length <= 0}]" >
    <div v-if="submitList.length > 0" class="table" >
      <div class="row" v-for="(item, index) in submitList" :key="index">
        <div v-for="(item2, index2) in item.arr" :key="index2" class="column textoverflow">
          <span class="nickname">{{ item2.nickname }}</span>
        </div>
        <div v-for="diffInex in (column - item.arr.length)" :key="diffInex" class="column textoverflow empty">
        </div>
      </div>
    </div>
    <div v-else class="empty-data-tip">{{ $t("passwordLuckDraws.暂无数据") }}</div>

    <button
      v-if="totalPageCount > pageNum"
      class="load-more"
      @click="clickLoadMore"
    >{{ $t("passwordLuckDraws.查看更多") }}</button>
  </div>
</template>

<script>

import {
  getPasswordRaffleSubmitList,
  getPasswordRaffleSubmitCount
} from "@/api/liveRequest/luckDawApi";

export default {
  name: "AudienceClickLoadList",
  props: {
      raffleId: String,
      pageSize: {
        type: Number,
        default: 20
      },
      column: {
        type: Number,
        default: 1 
      },
      luckDetailSubmitCount: { // 定时更新的 luckDetailSubmitCount，收到更新则需要请求 getPasswordRaffleSubmitCount 接口获取最新的分页信息和条数
        type: [Number, undefined], // 指定类型为 Number 或 undefined
        default: undefined // 设置默认值为 undefined
      },
      visibleType: {
        type: [String, undefined], // 指定类型为 String 或 undefined， visibleType: visible | hide | undefined
        default: undefined // 设置默认值为 undefined
      },
      page1ResultStr: {
        type: [String, undefined], // 指定类型为 String 或 undefined， page1ResultStr: "{list, pageCount}" | undefined
        default: undefined // 设置默认值为 undefined
      }
    },
    beforeDestroy() {
        this.unininList();
    },
    mounted() {
        if (this.visibleType !== 'hide' && !this.isInited)
            this.raffleId && this.ininList();
    },
    data() {
      return {
        isInited: false,
        pageNum: 1, // 当前页
        totalPageCount: 1, // 总页数
        totalCount: 1, // 总条数
        submitList: [],  // 提交的观众列表, 例如: [{id, arr:[submit1, submit2, submit3]}]
        loading: false,
        timer: undefined
      };
    },
    watch: {
      raffleId: {
        handler() {
          if (this.isInited) {
            this.unininList();
            this.raffleId && this.ininList();
          }
        }
      },
      visibleType: {
        handler() {
          if (this.visibleType !== 'hide') {
            if (!this.isInited)
                this.raffleId && this.ininList();
            else if (this.pageNum >= this.totalPageCount && !this.loading) { // 最后一页，需要重新加载此页新数据
                this.fetchPasswordRaffleSubmitList(this.pageNum, this.pageSize);
            }
          }
        }
      },
      luckDetailSubmitCount: {
        handler() {
          this.delayCheckLastPageListData();
        }
      }
    },
    methods: {
      ininList () {
        this.isInited = true;
        this.pageNum = 1;
        this.totalPageCount = 1;
        this.totalCount = 0;
        this.submitList = [];
        this.loading = false;
      
        this.fetchPasswordRaffleSubmitList(this.pageNum, this.pageSize);
      },
      unininList () {
        this.isInited = false;
        this.pageNum = 1;
        this.totalPageCount = 1;
        this.totalCount = 0;
        this.submitList = [];
        this.loading = false;
  
        this.timer && clearTimeout(this.timer);
        this.timer = undefined;
      },
      delayCheckLastPageListData () {
        if (!this.raffleId || !this.isInited || this.visibleType === 'hide' || this.timer || this.luckDetailSubmitCount === undefined)
          return;
  
        this.timer && clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          this.timer && clearTimeout(this.timer);
          this.timer = undefined;
  
          if (!this.loading && this.pageNum >= this.totalPageCount) { // 在最后一页，获取下是否有新的数据
            if (!this.raffleId || !this.isInited || this.visibleType === 'hide')
              return;
  
            const raffleId = this.raffleId;
            getPasswordRaffleSubmitCount(this.raffleId)
              .then((res) => {
                if (res.code !== 200 || !this.isInited || !this.raffleId || this.visibleType === 'hide' || this.raffleId !== raffleId)
                  return;
  
                const totalCount = res.data;
                let totalPageCount = Math.ceil(totalCount / this.pageSize);
                if (totalPageCount < 1)
                  totalPageCount = 1;
  
                const oldTotalCount = this.totalCount;
                const oldTotalPageCount = this.totalPageCount;
                this.totalCount = totalCount;
                this.totalPageCount = totalPageCount;
  
                if (oldTotalCount !== totalCount || oldTotalPageCount !== totalPageCount) {
                  this.fetchMoreData(this.pageNum);
                }
              });
          }
        }, 2000);
      },
      fetchPasswordRaffleSubmitList (pageNum, pageSize, onCallback, options={}) {
        if (!this.isInited || !this.raffleId || this.visibleType === 'hide') {
            this.loading = false;
            onCallback && onCallback(true);
            onCallback = undefined;
            return;
        }

        if (pageNum === 1 && this.luckDetailSubmitCount === undefined && this.page1ResultStr) {
            this.handlePasswordRaffleSubmitListResult(pageNum, JSON.parse(this.page1ResultStr), onCallback);
            this.loading = false;
            onCallback && onCallback(true);
            onCallback = undefined;
            return;
        }

        if (!options.ignoreUpdateLoading)
            this.loading = true;

        const raffleId = this.raffleId;

        getPasswordRaffleSubmitList(raffleId, {page: pageNum - 1, size: pageSize})
          .then((res) => {
            // console.log('finsh fetchPasswordRaffleSubmitList, raffleId:', raffleId, ' ,pageNum:', pageNum, ' ,pageSize:', pageSize, ' ,res:', res);
            if (!options.ignoreUpdateLoading)
                this.loading = false;

            if (res.code !== 200 || !this.isInited || !this.raffleId || this.visibleType === 'hide' || this.raffleId !== raffleId) {
                onCallback && onCallback(true);
                onCallback = undefined;
                return;
            }
  
            this.handlePasswordRaffleSubmitListResult(pageNum, res.data, onCallback);
          })
          .catch((err) => {
            console.error('getPasswordRaffleSubmitList catch err:', err, ' ,raffleId:', raffleId, ' ,pageNum:', pageNum, ' ,pageSize:', pageSize);
            if (!options.ignoreUpdateLoading)
                this.loading = false;

            onCallback && onCallback(false);
            onCallback = undefined;
          });
      },
      handlePasswordRaffleSubmitListResult (pageNum, resData, onCallback) {
        let {list, pageCount: totalCount} = resData; //pageCount: 总条数, pageNum:当前页码, pageSize:每页的个数
            
        // TODO qgs test 这是测试数据
        // totalCount = 155;
        
        let totalPageCount = Math.ceil(totalCount / this.pageSize);
        if (totalPageCount < 1)
          totalPageCount = 1;

        if (pageNum > totalPageCount) {
            onCallback && onCallback(true);
            onCallback = undefined;
            return;
        }

        this.totalCount = totalCount;
        this.totalPageCount = totalPageCount;

        this.deletePageNumSubmit(pageNum, true);

        const addItems = [];
        let lastIndexTmp = this.submitList.length;
        let lastItemTmp = this.submitList[this.submitList.length - 1];

        // TODO qgs test 这是假数据
        // for (let i=0; i< this.pageSize; i++) {
        //   list.push({nickname: `fake_${pageNum}_${i}`});
        // }

        for (let i=0, len=list.length; i<len; i++) {
            if (!lastItemTmp || lastItemTmp.arr.length >= this.column) {
                lastIndexTmp++;
                lastItemTmp = {id: lastIndexTmp, arr: []};
                addItems.push(lastItemTmp);
            }

            const submit = list[i];
            submit.pageNum = pageNum;
            lastItemTmp.arr.push(submit);
        }

        if (addItems.length)
            this.submitList.push(...addItems);

        onCallback && onCallback(true);
        onCallback = undefined;
      },
      fetchMoreData(forcePageNum, isUpdatePrevPage) {
        // 判断是否还有更多数据需要加载
        if (!this.isInited || !this.raffleId || this.visibleType === 'hide' || this.loading || this.pageNum >= this.totalPageCount)
          return;
  
        if (forcePageNum !== undefined)
          this.pageNum = forcePageNum;
        else
          this.pageNum++;
  
        this.deletePageNumSubmit(this.pageNum, false);

        if (isUpdatePrevPage && this.pageNum > 1) { // 更新上一页的数据
            this.loading = true;
            this.fetchPasswordRaffleSubmitList(this.pageNum-1, this.pageSize, () => {
                this.fetchPasswordRaffleSubmitList(this.pageNum, this.pageSize, () => {
                    this.loading = false;
                });
            }, {ignoreUpdateLoading: true});
            return;
        }

        this.fetchPasswordRaffleSubmitList(this.pageNum, this.pageSize);
      },
      clickLoadMore () {
        this.fetchMoreData();
      },
      deletePageNumSubmit (pageNum, isDeleteEq) {
        let isBreak;
        for (let index=this.submitList.length -1; index>=0; index--) {
            const arr2 = this.submitList[index].arr;
            
            for (let i2=arr2.length -1; i2>=0; i2--) {
                const item = arr2[i2];
                if (isDeleteEq && item.pageNum === pageNum)
                    arr2.splice(i2, 1);

                if (
                    pageNum > item.pageNum
                    || (!isDeleteEq && pageNum === item.pageNum)
                ) {
                    isBreak = true;
                    break;
                }
            }

            if (!arr2.length)
                this.submitList.splice(index, 1);
            
            if (isBreak)
                break;
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
.table {
  .row {
    display: flex;

    .column {
      flex: 1;
      margin: 4px;
    }
  }
}

.empty-data-tip{
  line-height: 60px;
  color: #909399;
  text-align: center;
  font-size: 12px;
}

.load-more {
  color: #3986EE;
  text-align: center;
  margin: 5px 0;
  border: none;
  background: none;
  text-align: center;
  transform: translateX(-50%);
  left: 50%;
  position: relative;
  cursor: pointer;
}
</style>